// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Ds-z","imageAndVideoCount":"Es-z","imageAndVideoContainer":"Fs-z","viewAllReviews":"Gs-z"};